import { RaffleImages } from "../raffle/images";
import { Box, Chip, Divider, Fade, Grid, List, ListItem, ListItemIcon, ListItemText, ListSubheader, Stack, Typography } from "@mui/material";
import RaffleTickets from "../raffle/tickets";
import { IRaffle } from "../../store/interfaces/IRaffle";
import { useIsMobileView } from "../../utils/responsive";
import { useAppSelector } from "../../store/hooks/useAppSelector";
import { RootState } from "../../store/types/rootState";
import TopPurchasers from "../raffle/topPurchasersPublic";
import { useGetTopPurchasersQuery } from "../../store/api";
import { getThemeByAccountId } from "../../utils/styleConstants";
import TicketsFinder from "../ticketsFinder";
import { useEffect, useState } from "react";
import { ITopPurchaser } from "../../store/interfaces/ITopPurchaser";
import CountdownTimer from "../common/Countdown";
import ProgressBar from "../common/ProgressBar";
import { AwardInformation } from "../raffle/awardInformation";
import RifasTrebolInfo from "../information/RifasTrebol";
import JGRInfo from "../information/JGRInfo";
import Conalot1 from '../../assets/images/conalot/conalot1.png'
import Conalot2 from '../../assets/images/conalot/conalot2.jepg.jpeg'
import Conalot3 from '../../assets/images/conalot/conalot3.jpg'
import GanaConSalazarInfo from "../information/GanaConSalazarInfo";
import { RaffleImages2 } from "../raffle/images2";
import { PreviewRaffleImages } from "../raffle/preview-images";
import RaffleTicketsV2 from "../raffle/ticketsV2";

interface ActiveRaffleProps {
  activeRaffle: IRaffle;
  isPreview?: boolean;
}


export const ActiveRaffle2 = ({ activeRaffle, isPreview }: ActiveRaffleProps) => {

  const isMobile = useIsMobileView();
  const accountInformation = useAppSelector(({ account }: RootState) => account);
  const [scrolled, setScrolled] = useState(false);

  const handleScroll = () => {
    if (window.scrollY > 500) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Grid container sx={{ background: getThemeByAccountId(accountInformation.id) === 'dark' ? '#000 !important' : '#FFF !important' }}>
      <Grid item xs={12} xl={12} lg={12} md={12} sm={12} padding={isPreview ? 0 : isMobile ? 0 : 2}>
        {
          activeRaffle.launchDate && <Grid p={4}> <CountdownTimer targetEpoch={activeRaffle.launchDate}></CountdownTimer> </Grid>
        }
        <Grid
        container
        sx={{
          position: 'sticky',
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: 'white',
          borderTop: `10px solid ${accountInformation.primaryColor}`,
          borderBottom: `10px solid ${accountInformation.primaryColor}`,
          color: '#000',
          padding: '10px',
          zIndex: 10,
          textAlign: 'center',
        }}
      >
        <Grid xs={4} xl={4} lg={4} md={4} sm={4}>
          <img
            src={accountInformation.logo}
            width={isPreview ? 60 : 120}
            height={isPreview ? 60 : 120}
            style={{ borderRadius: 20, position: 'absolute', left: 20 }}
            alt="Logo"
          />
        </Grid>
        <Grid xs={8} xl={8} lg={8} md={8} sm={8}>
          <Typography paddingLeft={2} variant="h6" fontWeight="bold" fontFamily={"Phrastic"} textTransform={"uppercase"} color={"black"}>
            {accountInformation.name}
          </Typography>
          <Typography paddingLeft={2} variant="body1" fontFamily={"Phrastic"} color={"black"}>
            {activeRaffle.name}
          </Typography>
        </Grid>
      </Grid>
        
        <Grid p={isPreview ? 2 : 15} px={4}>
          <Box borderRadius={20}>
            {isPreview ? <PreviewRaffleImages images={activeRaffle.awards.flatMap(element => element.images)}></PreviewRaffleImages> : <RaffleImages2 images={activeRaffle.awards.flatMap(element => element.images)}></RaffleImages2>}
            
          </Box>
        </Grid>

        <Grid container  xs={12} xl={12} lg={12} md={12} sm={12} padding={isMobile ? 0 : 1}>
            {getThemeByAccountId(accountInformation.id) === 'dark' ? <Grid 
            item 
            xl={12} lg={12} md={12} xs={12} sm={12} 
            display={"flex"} 
            justifyContent={"center"}
            sx={{
              position: "relative",
            }}
            paddingBottom={4}
          >
            <Typography 
              variant="h3" 
              textAlign={"center"} 
              fontFamily={"Phrastic"} 
              fontWeight={"bold"} 
              textTransform={"uppercase"} 
              sx={{
                position: "absolute", 
                top: "-60px",
                zIndex: 2,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {activeRaffle.name}
            </Typography>
          </Grid> :  
          <Grid item xl={12} lg={12} md={12} xs={12} sm={12}>
            <Typography variant="h3" textAlign={"center"} fontFamily={"Phrastic"} fontWeight={"bold"} textTransform={"uppercase"}>
              {activeRaffle.name}
            </Typography>
          </Grid> }

          
          {activeRaffle.awards.map((award, i) => (
            i < 2 &&
              <Grid item key={`award-${award.name}`} xs={12} xl={12} lg={12} md={12} sm={12} mt={5}>
                {
                 award.features.map((feature, index) => <Typography color={"white"} textAlign={"center"}>
                  {feature}
                 </Typography>)
                }
              </Grid>
            ))}
          </Grid>

        {accountInformation.id === 'super-rifas-latam' && <Box mt={6}>
          <ProgressBar raffleId={activeRaffle.id} type="bar"></ProgressBar>
        </Box> }
        { accountInformation.id === 'rifas-trebol' && <RifasTrebolInfo></RifasTrebolInfo> }
        { accountInformation.id === 'jgr1' && <JGRInfo></JGRInfo>}
        { accountInformation.id === 'gana-con-salazar' && <GanaConSalazarInfo></GanaConSalazarInfo>}
        <Grid>
          {activeRaffle.type !== 'promo' 
          && accountInformation.id !== 'oscar-alarcon' 
          // && accountInformation.id !== 'alex-vargas' 
          && accountInformation.id !== 'buenaventura' 
          && accountInformation.id !== 'ale-jef' 
          // && accountInformation.id !== 'una-vision' 
          && accountInformation.id !== 'jj-platinum' 
          && accountInformation.id !== 'el-rifazo' 
          // && accountInformation.id !== 'el-barines' 
          && accountInformation.id !== 'monino' 
          && accountInformation.id !== 'luis-bigrau' 
          // && accountInformation.id !== 'zpremio' 
          && accountInformation.id !== 'w-robles' 
          && accountInformation.id !== 'jgr1' 
          && accountInformation.id !== 'a-donde-la-negra' 
          && accountInformation.id !== 'agudojhonny' 
          && accountInformation.id !== 'angel-hernandez' 
          && accountInformation.id !== 'alex-hernandez' 
          && accountInformation.id !== 'alejandro-el-gochito' 
          && accountInformation.id !== 'wild-life-rescue' 
          && accountInformation.id !== 'motor-luck' 
          && accountInformation.id !== 'gana-con-johnbi' 
          && accountInformation.id !== 'yourrmann' 
          && accountInformation.id !== 'suena-en-grande' 
          && accountInformation.id !== 'hernancito-jr' 
          && accountInformation.id !== 'el-viejo' 
          // && accountInformation.id !== 'ruedas-extremas' 
          && accountInformation.id !== 'rifas-roalis' 
          && <TopPurchasers raffleId={activeRaffle.id}></TopPurchasers>}
        </Grid>


        {activeRaffle.type !== 'lottery' && <Grid sx={{ p: 4, pt: 0 }} pt={4}>
          <Typography variant="h6" textAlign={"center"} fontWeight={"bold"}>¿Cuantos tickets quieres?</Typography>
        </Grid>}
        <Grid item  xs={12} xl={12} lg={12} sm={12}>
            <RaffleTicketsV2 accountId={accountInformation.id} raffleId={activeRaffle.id} limit={activeRaffle.limit} ticketPriceUSD={activeRaffle.ticketPriceUSD} ticketPrice={activeRaffle.ticketPrice} availablePaymentMethods={activeRaffle.availablePaymentMethods} raffleType={activeRaffle.type} /> 
        </Grid>

            {accountInformation.id !== 'oscar-alarcon' 
              && accountInformation.id !== 'motor-luck' 
              && accountInformation.id !== 'zpremio' 
              && 
              <>
              <Divider></Divider>
              <Grid sx={{ p: 4, pt: 4 }}>
                <Typography variant="h6" fontWeight={"bold"}>Verificar mis tickets</Typography>
                <TicketsFinder isPublic={false} raffleId={activeRaffle.id} activeRaffleName={activeRaffle.name} limit={activeRaffle.limit} />
              </Grid>
              <Divider></Divider>
              </>
            }
            
            {activeRaffle.type === 'raffle' 
              && accountInformation.id === 'w-robles' 
              && 
              <>
              <Grid sx={{ p: 4, pt: 4 }}>
                <Stack justifyContent={"space-around"} direction={"row"} spacing={2}>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot1} alt="Ganadores" width={80} />
                  </Box>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot2} alt="Ganadores" width={80} />
                  </Box>
                  <Box sx={{ borderRadius: 2, background: '#fff', border: '1px solid #ccc', padding: 1 }}>
                    <img src={Conalot3} alt="Ganadores" width={80} />
                  </Box>
                </Stack>
              </Grid>
              <Divider></Divider>
              </>
            }
      </Grid>
    </Grid>
  );
};
